import request from '../request';

export function  getInfoAll(data) {
  return request({
    url: "/products",
    method: "get",
    data
  })
}

export function getInfoByID(id) {
  return request({
    url: `/products/${id}`,
    method: "get"
  })
}

export function postInfo(data) {
  return request({
    url: "/products",
    method: "post",
    data
  })
}

export function putInfo(data) {
  return request({
    url: `/products/${data.get("id")}`,
    method: "post",
    data
  })
}

export function deleteInfo(id) {
  return request({
    url: `/products/${id}`,
    method: "delete"
  })
}
